/*
 Auto-generated by generate-java-to-ts-maven-plugin. Do not edit.
 Source: de.mhus.vance.api.ursahooks.UrsaHookSource
*/
export var UrsaHookSource;
(function (UrsaHookSource) {
    UrsaHookSource["PROJECT"] = "PROJECT";
    UrsaHookSource["VANCE"] = "VANCE";
})(UrsaHookSource || (UrsaHookSource = {}));
//# sourceMappingURL=UrsaHookSource.js.map